import { inject, Injectable } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { Subscribable } from '@mobilefirstdev/base-angular';
import { InjectedDeserializer } from '../models/protocols/deserialize';
import { AppIsActiveService } from './app-is-active.service';

declare global {
  interface Window {
    injector: InjectorService | undefined;
  }
}

@Injectable({ providedIn: 'root' })
export class InjectorService extends Subscribable {
  /**
   * The constructor uses inject() on purpose. Why?
   * All parameters injected into the constructor as parameters initialize before window.injector = this.
   * We can't have this, because the cache service relies on window.injector being set.
   * Therefore, wait until window.injector is set before initializing services.
   *
   * TL;DR: Don't inject services as params. Use inject() in constructor body instead.
   */
  constructor(public sanitizer: DomSanitizer) {
    super();
    window.injector = this;
    this.appIsActiveService = inject(AppIsActiveService);
  }

  public appIsActiveService: AppIsActiveService;

  /**
   * This lives in here as to not create circular import dependencies. If you: import {Deserialize} from '...'
   * then there is a high likelihood that you will create a "circular import dependency", because the Deserialize
   * class imports references to most of the classes in this project.
   *
   * TL;DR: Don't import Deserialize into classes. Use the injector instead.
   */
  public Deserialize: typeof InjectedDeserializer = InjectedDeserializer;

  override destroy() {
    super.destroy();
    window.injector = undefined;
  }
}
